import React, {useState, useEffect} from 'react';
import {Upload, Modal} from 'antd';
import {getBase64} from 'src/utils/utils';
import {useIntl} from 'react-intl';

 const ImageUploadNoAction = (props) => {
  const {URL, fileList, onChange, headers, multiple, disabled,onRemove,beforeUpload, setFileImage} = props;

  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const intl = useIntl();

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
  };

  const handleCancelImage = () => {
    setPreviewVisible(false);
    setFileImage(null);
  }

  return (
    <>
      <Upload
        multiple = {multiple}
        name = 'file'
        accept = 'image/*'
        action = {`${URL}`}
        listType = 'picture-card'
        fileList = {fileList}
        onPreview = {handlePreview}
        onChange = {onChange}
        headers = {headers}
        onRemove = { onRemove ? onRemove : null }
        beforeUpload = {beforeUpload}
      >
        {(!!multiple || (fileList && fileList.length < 1)) && !disabled && (
          <div>
            <i className='fas fa-plus'></i>
            <div style={{marginTop: 8}}>{intl.formatMessage({id: 'UPLOAD'})}</div>
          </div>
        )}
      </Upload>
      <Modal visible={previewVisible} title={''} footer={null} onCancel={handleCancelImage}>
        <img alt='example' style={{width: '100%'}} src={previewImage} />
      </Modal>
    </>
  );


};const ImageUpload = (props) => {
  const {URL, fileList, onChange, headers, multiple, disabled,onRemove,beforeUpload} = props;

  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const intl = useIntl();

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
  };

  const handleCancelImage = () => setPreviewVisible(false);

  return (
    <>
      <Upload
        multiple={multiple}
        name='files'
        accept='image/*'
        action = {`${URL}`}
        listType='picture-card'
        fileList={fileList}
        onPreview={handlePreview}
        onChange={onChange}
        headers={headers}
        onRemove={ onRemove ? onRemove : null }
        beforeUpload ={beforeUpload}
      >
        {(!!multiple || (fileList && fileList.length < 1)) && !disabled && (
          <div>
            <i className='fas fa-plus'></i>
            <div style={{marginTop: 8}}>{intl.formatMessage({id: 'SUBSCRIBER.UPLOAD'})}</div>
          </div>
        )}
      </Upload>
      <Modal visible={previewVisible} title={''} footer={null} onCancel={handleCancelImage}>
        <img alt='example' style={{width: '100%'}} src={previewImage} />
      </Modal>
    </>
  );
};

export default ImageUpload;
export {ImageUploadNoAction};